import { loginRequest } from 'msConfig';

export const acquireToken = async (instance, accounts) => {
  try {
    const request = { ...loginRequest, account: accounts[0] };

    const response = await instance.acquireTokenPopup(request);

    return response?.accessToken || '';
  } catch (err) {
    console.error('Failed to acquire token:', err);
    throw err;
  }
};
